import Input from './Input';
import Textarea from './Textarea';

export { Input, Textarea };
